module.exports = __webpack_public_path__ + "static/img/icon-spring.c11a3124.png";